import { createContext } from 'react';
import utils from 'utils';

type OnboardingContextProps = {
  canUserSeeOnboarding: boolean;
  onShowOnboarding: () => void;
};

export default createContext<Partial<OnboardingContextProps>>({
  canUserSeeOnboarding: false,
  onShowOnboarding: utils.noop,
});
